import { Check, X } from "lucide-react";
import { SectionHeading } from "@/components/site/ui";
import { useFetch } from "@/lib/useFetch";

const ROWS = ["Google Business", "SEO", "Social Media", "Posts", "Reels", "Influencer Marketing", "Website Support", "Reporting", "Dedicated Support"];

function Cell({ v }) {
    if (v === true) return <Check className="w-5 h-5 text-growth mx-auto" />;
    if (v === false || v == null) return <X className="w-4 h-4 text-cream-soft/30 mx-auto" />;
    return <span className="text-sm font-semibold text-cream">{v}</span>;
}

export function Comparison() {
    const { data: packages } = useFetch("/packages", []);
    const pkgs = packages || [];
    return (
        <section className="bg-teal-900 py-20" data-testid="comparison-section">
            <div className="container-x">
                <div className="mb-10 text-center flex flex-col items-center">
                    <SectionHeading center eyebrow="Compare" title="Package Comparison"
                        subtitle="See exactly what's included in each plan at a glance." />
                </div>
                <div className="overflow-x-auto rounded-2xl border border-brandborder card-teal">
                    <table className="w-full min-w-[560px] text-center">
                        <thead>
                            <tr className="border-b border-brandborder">
                                <th className="text-left p-4 text-cream-soft font-medium text-sm">Feature</th>
                                {pkgs.map((p) => (
                                    <th key={p.slug} className="p-4">
                                        <div className={`font-bold ${p.popular ? "text-gold" : "text-cream"}`}>{p.name}</div>
                                        <div className="font-mono text-sm text-cream-soft">₹{p.price.toLocaleString("en-IN")}</div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {ROWS.map((row, i) => (
                                <tr key={row} className={i % 2 ? "bg-teal-800/30" : ""}>
                                    <td className="text-left p-4 text-sm text-cream-soft">{row}</td>
                                    {pkgs.map((p) => <td key={p.slug + row} className="p-4"><Cell v={(p.compare || {})[row]} /></td>)}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
}
